import AppStore from '../stores/index';
import {
  notifySuccess,
  notifyError,
  notifyWarning,
  notifyInfo,
} from '../stores/notification/actions';

export function showSuccess(successMsg: string) {
  AppStore.dispatch(notifySuccess(successMsg));
}

export function showError(errorMsg: string) {
  AppStore.dispatch(notifyError(errorMsg));
}

export function showWarning(warningMsg: string) {
  AppStore.dispatch(notifyWarning(warningMsg));
}

export function showInfo(infoMsg: string) {
  AppStore.dispatch(notifyInfo(infoMsg));
}
